import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationEmailService } from 'libs/core/validation-email/validation-email.service';
import { catchError, delay, finalize, switchMap, throwError, timer } from 'rxjs';
import { ButtonComponent, IconComponent } from "libs/shared";
@Component({
  selector: 'validation-email',
  imports: [CommonModule, ButtonComponent, IconComponent],
  templateUrl: './validation-email.html',
})
export class ValidationEmail {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private service = inject(ValidationEmailService);

  loading = signal(true);

  private signInUrl = '/signin';
  private errorUrl = '/error';

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token')?.trim();

    if (!token) {
      this.router.navigateByUrl(this.errorUrl);
      return;
    }

    this.loading.set(true);

    //S'ha posat un timer per que hi hagi sensació que està passant algo, sino potser va massa ràpid
    this.service
      .validateEmail(token)
      .pipe(
        delay(2000),
        catchError((error) => {
          return timer(2000).pipe(
            switchMap(() => throwError(() => error))
          );
        }),
      )
      .subscribe({
        next: () => {
          this.loading.set(false);
        },
        error: () => {
          this.router.navigateByUrl(this.errorUrl);
        },
      });
  }

  goToSignin() {
    this.router.navigate([this.signInUrl]);
  }

}